// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__hDG0-","buttonsContainer":"styles_buttonsContainer__2akLx","delete":"styles_delete__1en2X","cancel":"styles_cancel__xoiLz"};